/**
 * Annual “gold special” campaign (discounted annual SKUs + annual-only UX on /pricing).
 *
 * When `true`:
 * - Pricing page hides the monthly/annual switch and keeps users on annual.
 * - `PricingPackeges` uses `goldSpecial` → `ANNUAL_DISCOUNT_50` products for eligible users.
 * - Hero promo copy + countdown on `/pricing` (via `annualPromo` state from the grid).
 * - Site header shows the annual discount banner for free Hexomatic users (links to `/pricing/`).
 *
 * When `false`:
 * - Normal monthly/annual toggle and standard product intervals on `/pricing`.
 *
 * Flip this to `true` to re-run the same promotion without re-threading one-off code.
 */
export const PRICING_ANNUAL_GOLD_SPECIAL_PROMO_ACTIVE = false;
